export const BAZAARVOICE_FORM_SELECTOR = '[data-bv-show="inpage_submission"]';
